import { render } from "./Details.vue?vue&type=template&id=2206e4ef"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render

export default script